<template>
  <el-card>
    <h1>{{ langData.settlement }}</h1>
    <!-- 搜索 -->
    <el-row class="search">
      <el-col :xs="24" :lg="5">
        <el-date-picker v-model="startDates" :format="getFormattedDate" type="week" :placeholder="langData.selectData"
          :picker-options="{ firstDayOfWeek: 1 }" style="width: 100%" @change="formatterTimes">
        </el-date-picker>
      </el-col>
      <el-col :xs="12" :lg="2" style="width: max-content">
        <el-button type="primary" @click="query(1)">{{
          langData.search
        }}</el-button>
      </el-col>
      <el-col :xs="12" :lg="2">
        <el-button type="primary" plain icon="el-icon-plus" v-loading="dwnLoading" @click="download">{{ langData.export
          }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="list" :class="{ ar: isAr == 2 }" style="width: 100%; margin-bottom: 20px" v-loading="loading"
        border max-height="600">
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" min-width="160" sortable prop="date"
          :label="langData.date"></el-table-column>
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" min-width="160" sortable prop="country"
          :label="langData.country"></el-table-column>
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" min-width="160" sortable prop="name" :label="langData.name">
          <template slot-scope="scope">
            <span class="notranslate">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column :fixed="isMobile ? false : isAr == 2 ? false : 'left'" min-width="160" sortable prop="rid"
          :label="langData.rid"></el-table-column>
        <el-table-column min-width="220" sortable prop="rangeBalance" :label="langData.rangeBalance">
          <template slot-scope="scope">
            {{ scope.row.rangeBalance * cr }}
          </template>
        </el-table-column>
        <el-table-column min-width="240" sortable prop="rangeBalanceUSD" :label="langData.rangeBalanceUSD">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.rangeBalanceUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column min-width="220" sortable prop="lastWeekRangeBalance" :label="langData.lastWeekRangeBalance">
          <template slot-scope="scope">
            {{ scope.row.lastWeekRangeBalance * cr }}
          </template>
        </el-table-column>
        <el-table-column min-width="240" sortable prop="lastWeekRangeBalanceUSD" :label="langData.lastWeekRangeBalanceUSD">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.lastWeekRangeBalanceUSD)}` }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination layout="prev, pager, next" :total="total" :page-size="pageSize"
        :hide-on-single-page="true" @current-change="handleCurrentChange" :pager-count="isMobile ? 5 : 7">
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { getSettlementData, downloadDetail } from '@/api/report.js'
import { settlement } from '@/utils/lang.js'
import { downloadFile } from '@/utils/download.js'
import { cr } from '@/config'

export default {
  data() {
    return {
      cr: cr,
      loading: false,
      dwnLoading: false,
      list: [],
      startDates: null,
      langData: {},
      isAr: parseInt(sessionStorage.getItem('lang')),
      isMobile: window.innerWidth <= 768,
      agentType: [
        JSON.parse(sessionStorage.getItem('loginData')).agentType[0].value,
      ],
      search: {
        startDate: null,
        endDate: null,
        lastWeekStartDate: null,
        lastWeekEndDate: null,
      },
      agentName: '',
      agentTypes: JSON.parse(sessionStorage.getItem('loginData')).agentType,
      currentPage: 1,
      total: 0,
      pageSize: 100,
    }
  },
  created() {
    if (sessionStorage.getItem('lang')) {
      this.langData = settlement[parseInt(sessionStorage.getItem('lang'))]
    } else {
      window.sessionStorage.setItem('lang', '1')
      this.langData = settlement[1]
    }
    this.setDefaultLastWeek()
    this.query(1)

    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.lang': function (val) {
      this.langData = settlement[val]
      this.isAr = val
    },
  },
  computed: {
    getFormattedDate() {
      // 如果 startDate 或 search.startDate 或 search.endDate 为空，则使用默认格式
      if (!this.search.startDate || !this.search.endDate) {
        return 'yyyy WeekWW(--)' // 默认显示一个占位符
      }

      // 否则返回具体的日期格式
      // startDate 和 endDate 格式为 YYYY-MM-DD，需要提取 MM-DD 部分并替换为 MM/DD
      return `yyyy WeekWW(${this.search.startDate
        .slice(5)
        .replace('-', '/')}-${this.search.endDate.slice(5).replace('-', '/')})`
    },
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    download() {
      this.dwnLoading = true
      downloadDetail(
        {
          ...this.search,
          lang: ['en', 'zh', 'ar', 'es'][this.isAr || 0],
          page: -1
        },
        3
      )
        .then((response) => {
          this.dwnLoading = false
          this.$message.success('开始下载')
          downloadFile(response.data, this.langData.settlement)
        })
        .finally(() => {
          this.dwnLoading = false
        })
    },
    formatDate(row, column) {
      const time = row[column.property]
      return `${Math.floor(time / 60)}小时${time % 60}分`
    },
    formatterTimes(date) {
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      // 将 date 往前推一天
      date.setDate(date.getDate() - 1)

      const today = new Date()
      const sevenDaysLater = new Date(date)
      sevenDaysLater.setDate(date.getDate() + 6)

      const endDate = sevenDaysLater > today ? today : sevenDaysLater

      const lastWeekStart = new Date(date)
      lastWeekStart.setDate(date.getDate() - date.getDay() - 6)
      const lastWeekEnd = new Date(date)
      lastWeekEnd.setDate(date.getDate() - date.getDay())

      this.search = {
        startDate: formatDate(date),
        endDate: formatDate(endDate),
        lastWeekStartDate: formatDate(lastWeekStart),
        lastWeekEndDate: formatDate(lastWeekEnd),
      }
    },

    formatDate(row, column) {
      if (!row[column.property]) return ''
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.query()
    },
    handleClose() {
      this.dialogVisible = false
      this.agentName = ''
      this.agentType = [this.agentTypes[0].value]
      this.agentTypes = JSON.parse(
        sessionStorage.getItem('loginData')
      ).agentType
    },
    Creates() {
      if (JSON.parse(sessionStorage.getItem('loginData')).canCreateSon == 1) {
        return true
      }
      return false
    },
    // 获取列表
    async query(page) {
      if (page) {
        this.currentPage = page
      }
      this.loading = true
      const { data: res } = await getSettlementData({
        ...this.search,
        page: this.currentPage,
      })
      this.loading = false  
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })
      this.list = res.data.data
      this.total = res.data.total
    },

    // 获取创建
    async create() {
      let agentType = this.agentType.join()
      const { data: res } = await getAgencyregister({
        agentId: JSON.parse(sessionStorage.getItem('loginData')).agentId,
        agentType: agentType,
        agentName: this.agentName,
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })

      this.handleClose()
      this.query()
    },

    // 设置默认上周的值
    setDefaultLastWeek() {
      const today = new Date()
      const dayOfWeek = today.getDay()
      const startOfLastWeek = new Date(today)
      startOfLastWeek.setDate(today.getDate() - dayOfWeek - 5) // 设置为上周一
      this.startDates = startOfLastWeek
      this.formatterTimes(startOfLastWeek)
    },
  },
}
</script>

<style lang="scss" scoped></style>